import axios from "axios";

const CUSTOMER_URI_PREFIX = "/v1/customer";
const CUSTOMER_URIS = {
  GET_LIST_IMPORT_CONFIRM: `${CUSTOMER_URI_PREFIX}/list-confirm`,
  IMPORT_CONTINUE: `${CUSTOMER_URI_PREFIX}/import-continue`,
  GET_LIST_HISTORY_ALL_CUSTOMER: `${CUSTOMER_URI_PREFIX}/history`,
  GET_LIST_HISTORY_CUSTOMER: (customerId) =>
    `${CUSTOMER_URI_PREFIX}/${customerId}/history`,
};

export default {
  getHistoryAllCustomer(params) {
    return axios.get(CUSTOMER_URIS.GET_LIST_HISTORY_ALL_CUSTOMER, {
      params,
    });
  },
  getHistoryOfCustomer(params) {
    const { customerId, ...rest } = params;
    return axios.get(CUSTOMER_URIS.GET_LIST_HISTORY_CUSTOMER(customerId), {
      params: { ...rest, id: customerId },
    }); 
  },
  getListConfirmImportCustomer(params) {
    return axios.get(CUSTOMER_URIS.GET_LIST_IMPORT_CONFIRM, { params });
  },
  importContinueCustomer(data) {
    return axios.post(CUSTOMER_URIS.IMPORT_CONTINUE, data);
  },
};



// WEBPACK FOOTER //
// ./src/services/customer-service.js